module.exports = __webpack_public_path__ + "img/color-calculator-icon.7f87a51a.svg";